import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const mastheadSlice = createSlice({
	name: 'masthead',
	initialState: {pageTitle: 'Detections'},
	reducers: {
        setPageTitle: (state, action: PayloadAction<string>) => {
            state.pageTitle = action.payload;
        },
	},
});

export const { setPageTitle } = mastheadSlice.actions;
export default mastheadSlice.reducer;
